import { http } from '@pendo/http';

export function loadLabels () {
    return http
        .get('/api/s/_SID_/vocItem/labels')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createLabel ({ label, category = null }) {
    return http
        .post(
            '/api/s/_SID_/vocItem/labels',
            { label, ...(category && { category }) },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateLabel (labelId, name, categoryId = null) {
    return http
        .patch(`/api/s/_SID_/vocItem/labels/${labelId}`, {
            name,
            ...(categoryId ? { categoryId } : { removeCategory: true }),
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteLabel (labelId) {
    return http.delete(`/api/s/_SID_/vocItem/labels/${labelId}`).catch((err) => {
        throw err;
    });
}

export function loadAssociatedItemsForLabel ({ labelId }) {
    return http
        .get(`/api/s/_SID_/vocItem/labels/${labelId}/usage`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateCategory (categoryId, name) {
    return http
        .patch(`/api/s/_SID_/vocItem/categories/${categoryId}`, { name })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteCategory (categoryId) {
    return http.delete(`/api/s/_SID_/vocItem/categories/${categoryId}`).catch((err) => {
        throw err;
    });
}

export function loadAssociatedItemsForCategory ({ categoryId }) {
    return http
        .get(`/api/s/_SID_/vocItem/categories/${categoryId}/usage`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
